import React from "react";
import "../../../Styles/Story.css";

function Contact() {
  return (
    <div className="contact-page">
      {/* Header */}
      <section className="contact-header">
        <h1>Contact Us</h1>
        <p>
          We’re here to help. Reach out to Elumia Med Store for product
          information, support, or partnership inquiries.
        </p>
      </section>

      {/* Main Content */}
      <section className="contact-content">
        {/* Left - Contact Info */}
        <div className="contact-info">
          <div className="info-card">
            <h3>📍 Our Location</h3>
          <p>
    Elumia Med Store <br />
    NVT Wireless Trading <br />
    Al Qusais <br />
    Dubai, United Arab Emirates
  </p>
          </div>

          <div className="info-card">
            <h3>📞 Call Us</h3>
            <p>+971 50 257 6257</p>
            {/* <p>Mon – Sat, 9:00 AM – 7:00 PM</p> */}
          </div>

          <div className="info-card">
            <h3>✉️ Email</h3>
            <p>info@elumiamedstore.com</p>
            {/* <p>We reply within 24 hours</p> */}
          </div>
        </div>

        {/* Right - Contact Form */}
        <div className="contact-form">
          <h2>Send Us a Message</h2>

          <form>
            <div className="form-row">
              <input type="text" placeholder="Full Name" required />
              <input type="email" placeholder="Email Address" required />
            </div>

            <input type="text" placeholder="Subject" />

            <textarea
              rows="5"
              placeholder="Write your message here..."
              required
            ></textarea>

            <button type="submit">Submit Message</button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default Contact;


